<template>
  <div>
    <v-tabs>
      <v-tab>Table</v-tab>
      <v-tab>Graph</v-tab>
      <v-tab-item>
        <v-data-table
            dense
            :headers="getColumns"
            :items="itemList"
            item-key="id"
            class="elevation-1"
            :options.sync="options"
            @update:options="updateOptions"
            :server-items-length="totalRecords"
            :loading="loading"
            :footer-props="{
          'items-per-page-options': [-1, 10, 15, 20, 50, 100]
        }"
            hide-default-footer
            :height="windowHeight"
            fixed-header
            ref="left_table"
        >
          <template v-slot:top>
            <v-toolbar dense class="mt-2 pt-1 mb-2" elevation="1" color="gridtoolbar">
              <v-divider></v-divider>
              <v-switch
                  v-model="briefView"
                  label="brief View"
                  class="ml-5 mt-4"
                  dark
              ></v-switch>
            </v-toolbar>
          </template>
          <template v-slot:item.week_start="{ item }">
            <BatchRunYearWeekLink :item="item"></BatchRunYearWeekLink>
          </template>
          <template v-slot:item.notion_id="{ item }">
            <v-row>
              <v-icon
                  v-if="item.notion_id != null"
                  color="primary"
                  size="20"
                  @click="onNotion(item)"
              >
                mdi-alpha-n-box-outline
              </v-icon>
            </v-row>
          </template>
          <template v-slot:item.warning="{ item}">
            <BatchRunWarning :warning="item.warning"/>
          </template>

          <template v-slot:item.smd_plan_fte="{ item }">{{ Math.round(item.smd_plan_fte * 8) }}</template>
          <template v-slot:item.smd_work_fte="{ item }">{{ Math.round(item.smd_work_fte * 8) }}</template>
          <template v-slot:item.tht_plan_fte="{ item }">{{ Math.round(item.tht_plan_fte * 8) }}</template>
          <template v-slot:item.tht_work_fte="{ item }">{{ Math.round(item.tht_work_fte * 8) }}</template>

          <template v-slot:item.smd_performance="{ item }">
            <BatchRunProgressBar
                v-model="item.smd_performance"
            ></BatchRunProgressBar>
          </template>
          <template v-slot:item.smd_performance="{ item }">
            <BatchRunProgressBar
                v-model="item.smd_performance"
            ></BatchRunProgressBar>
          </template>
          <template v-slot:item.tht_performance="{ item }">
            <BatchRunProgressBar
                v-model="item.tht_performance"
            ></BatchRunProgressBar>
          </template>
          <template v-slot:item.production_performance="{ item }">
            <BatchRunProgressBar
                v-model="item.production_performance"
            ></BatchRunProgressBar>
          </template>

          <template v-slot:item.smd_performance_3w="{ item }">
            <BatchRunProgressBar
                v-model="item.smd_performance_3w"
            ></BatchRunProgressBar>
          </template>
          <template v-slot:item.smd_performance_3w="{ item }">
            <BatchRunProgressBar
                v-model="item.smd_performance_3w"
            ></BatchRunProgressBar>
          </template>
          <template v-slot:item.tht_performance_3w="{ item }">
            <BatchRunProgressBar
                v-model="item.tht_performance_3w"
            ></BatchRunProgressBar>
          </template>
          <template v-slot:item.production_performance_3w="{ item }">
            <BatchRunProgressBar
                v-model="item.production_performance_3w"
            ></BatchRunProgressBar>
          </template>
          <template v-slot:item.production_performance_avg="{ item }">
            <BatchRunProgressBar
                v-model="item.production_performance_avg"
            ></BatchRunProgressBar>
          </template>

          <template v-slot:item.smd_hist="{ item }">
            <BatchRunProgressBar legend="1W" v-model="item.smd_performance"></BatchRunProgressBar>
            <BatchRunProgressBar legend="3W" v-model="item.smd_performance_3w"></BatchRunProgressBar>
          </template>
          <template v-slot:item.tht_hist="{ item }">
            <BatchRunProgressBar legend="1W" v-model="item.tht_performance"></BatchRunProgressBar>
            <BatchRunProgressBar legend="3W" v-model="item.tht_performance_3w"></BatchRunProgressBar>
          </template>
          <template v-slot:item.production_hist="{ item }">
            <BatchRunProgressBar legend="1W" v-model="item.production_performance"></BatchRunProgressBar>
            <BatchRunProgressBar legend="3W" v-model="item.production_performance_3w"></BatchRunProgressBar>
            <BatchRunProgressBar legend="AVG" v-model="item.production_performance_avg"></BatchRunProgressBar>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <BatchRunHistoryGraph/>
      </v-tab-item>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import BaseTaskProgress from "@/components/BaseTaskProgress"
import BaseModal from "@/components/Base/BaseModal";
import BatchRunBadge from "@/components/BatchRun/BatchRunBadge"
import BatchRunWarning from "@/components/BatchRun/BatchRunWarning"
import BatchRunProgressBar from "@/components/BatchRun/BatchRunProgressBar";
import BatchRunYearWeekLink from "@/components/BatchRun/BatchRunYearWeekLink";
import BatchRunHistoryGraph from "@/components/BatchRun/BatchRunHistoryGraph";

export default {
  name: 'BatchRunHistoryList',
  props: {
    'subheight': {type: [Number], default: 140},
  },

  components: {
    BaseDeleteDialog,
    BaseTaskProgress,
    BaseModal,
    BatchRunBadge,
    BatchRunWarning,
    BatchRunProgressBar,
    BatchRunYearWeekLink,
    BatchRunHistoryGraph,
  },

  computed: {
    ...mapGetters('BatchRunHistoryList', ['getColumns']),
    ...mapFields('BatchRunHistoryList', ['options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive', 'filters']),
  },

  methods: {
    ...mapActions('BatchRunHistoryList', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems']),
    onResize() {
      this.windowHeight = (window.innerHeight - this.subheight) + 'px'
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      // this.filters['delivery_date'] = 'empty'
      this.fetchItemList()
    }, 800),

    updateOptions() {
      // console.log('updateOptions', this.filters)
      // this.filters['delivery_date'] = 'empty'
      this.fetchItemList()
    },

    onSyncNotion() {
      // console.log('onSyncNotion')
      this.fetchSyncNotionSelectedItems();
    },
    onRestore() {
      // console.log('onRestore')
      this.fetchRestoreSelectedItems();
    },
    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },
    getItemColor(item) {
      if (item.smd > 0 && item.tht > 0)
        return 'purple'
      if (item.tht > 0)
        return 'blue'
      return 'orange'
    },
    onStartDrag(event, item) {
      // console.log('onStartDrag', event, item)
      event.dataTransfer.setData('itemID', item.id)
    },
    onNotion(item) {
      // console.log('onNotion', item)
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize);
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      hover: false,
      windowHeight: (window.innerHeight - this.subheight) + 'px',
    }
  }
}
</script>

<style lang="css" scoped>
.stackSheet {
    position: relative;
}
.stackSpark {
    position: absolute;
    top: 0;
    left: 0;
}
</style>
